// modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// imports
import { Stack } from './stack.component';
import { StackItem } from './stack-item.directive';

@NgModule({
  declarations: [
    Stack,
    StackItem,
  ],
  exports: [
    Stack,
    StackItem,
  ],
  imports: [
    CommonModule,
  ]
})
class StackModule { }

export { Stack, StackItem, StackModule };
